function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "websitepage",
  d: "M14.633,19.665H10.452V15.484h4.181Zm5.289,0H15.741V15.484h4.181Zm-10.578,0H5.163V15.484H9.344v4.181ZM19.922,6.443V14.15H5.163V6.443Zm2.116-2.216H3.1V21.6H22.037V4.227h0ZM0,24.678V1.154H25.135V24.677H0Z",
  transform: "translate(0.25 -0.904)",
  fill: "#ac1ede",
  stroke: "#fff",
  strokeWidth: 0.5
});

var SvgWebsitepage = function SvgWebsitepage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.635,
    height: 24.023,
    viewBox: "0 0 25.635 24.023",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebsitepage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/websitepage.2b129e31.svg";
export { ForwardRef as ReactComponent };